import Vue from "vue";
import Router from "vue-router";
// 主页
import Index from "@/pages/index/index";
// 首页
import Home from "@/pages/home/home";
// 公司主页
import CompanyHome from "@/pages/company-home/company-home";
// 公司介绍
import CompanyIntr from "@/pages/company-intr/company-intr";
// 联系公司
import CompanyRelation from "@/pages/company-relation/company-relation";
// 公司历程
import CompanyCourse from "@/pages/company-course/company-course";
// 常见问题
import CompanyIssue from "@/pages/company-issue/company-issue";
// 企业服务首页
import EnterpriseHome from "@/pages/enterprise-home/enterprise-home";
// 客户案例
import EnterpriseCase from "@/pages/enterprise-case/enterprise-case";
// 在线招聘服务
import EnterpriseServer from "@/pages/enterprise-server/enterprise-server";
// PRO招聘服务
import EnterpriseServerOne from "@/pages/enterprise-server-one/enterprise-server-one";
// 短工招聘服务
import EnterpriseServerTwo from "@/pages/enterprise-server-two/enterprise-server-two";
// 企业增值服务
import EnterpriseServerThree from "@/pages/enterprise-server-three/enterprise-server-three";
// 播聘新闻
import ShowNews from "@/pages/show-news/show-news";
// 播聘新闻详情
import ShowNewsDetail from "@/pages/show-news-detail/show-news-detail";
// 帮助中心
import ShowHelp from "@/pages/show-help/show-help";
// 隐私政策
import ShowPrivacyPolicy from "@/pages/show-privacy-policy/show-privacy-policy";
// 播聘资讯
import ShowMessage from "@/pages/show-message/show-message";
//  工作技巧
import showAcrobatics from "@/pages/show-acrobatics/show-acrobatics";
//职场故事
import showStory from "@/pages/show-story/show-story";
//公司成长
import CompanyGrow from "@/pages/company-grow/company-grow";
//公司荣誉
import CompanyHonor from "@/pages/company-honor/company-honor";
//隐私政策
import PrivacyRules from "@/pages/privacy-rules/privacy-rules";
//招聘技巧
import RecruitmentSkills from "@/pages/recruitment-skills/recruitment-skills";
// 求职技巧
import JobHuntingSkills from "@/pages/job-hunting-skills/job-hunting-skills";
// 职场资讯
import bopingRouter from "@/pages/show-news/show-bopin-news";
// 职场资讯(查看详情)
import showNewsAge from "@/pages/show-news-age/show-news-age";
//招聘技巧
import recruitmentSkillsTo from "@/pages/recruitment-skills_to/recruitment-skills_to";
//求职技巧
import jobHuntingSkillsTo from "@/pages/job-hunting-skills-to/job-hunting-skills-to";
//
import showNewsLing from "@/pages/show-news-ling/show-news-ling";

import showLive from "@/pages/show-live/show-live";

import observeThe from "@/pages/observe-the/observe-the";

// 面试邀约
import AcceptInterview from "@/pages/accept-interview/accept-interview";
// 企业用户桌面端
import EnterpriseUserDesktop from "@/pages/enterprise-user-desktop/index";
// 自投简历
import EditResume from "@/pages/edit-resume/index";
// 下载app
import DownloadApp from "@/pages/app-download/index";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "Index",
      component: Index,
      redirect: "/home",
      children: [
        {
          path: "/home",
          name: "Home",
          component: Home,
        },
        {
          path: "/company-home",
          name: "CompanyHome",
          component: CompanyHome,
          children: [
            {
              path: "/company-intr",
              name: "CompanyIntr",
              component: CompanyIntr,
            },
            {
              path: "/company-course",
              name: "CompanyCourse",
              component: CompanyCourse,
            },
            {
              path: "/company-relation",
              name: "CompanyRelation",
              component: CompanyRelation,
            },
            {
              path: "/company-issue",
              name: "CompanyIssue",
              component: CompanyIssue,
            },
          ],
        },
        {
          path: "/enterprise-home",
          name: "EnterpriseHome",
          component: EnterpriseHome,
        },
        {
          path: "/enterprise-case",
          name: "EnterpriseCase",
          component: EnterpriseCase,
        },
        {
          path: "/show-news-age",
          name: "showNewsAge",
          component: showNewsAge,
        },
        {
          path: "/enterprise-server",
          name: "EnterpriseServer",
          component: EnterpriseServer,
        },
        {
          path: "/enterprise-server-one",
          name: "EnterpriseServerOne",
          component: EnterpriseServerOne,
        },
        {
          path: "/enterprise-server-two",
          name: "EnterpriseServerTwo",
          component: EnterpriseServerTwo,
        },
        {
          path: "/enterprise-server-three",
          name: "EnterpriseServerThree",
          component: EnterpriseServerThree,
        },
        // 企业用户桌面端
        {
          path: "/enterprise-user-desktop",
          name: "EnterpriseUserDesktop",
          component: EnterpriseUserDesktop,
        },
        {
          path: "/show-news",
          name: "ShowNews",
          component: ShowNews,
        },

        {
          path: "/show-news-detail",
          name: "ShowNewsDetail",
          component: ShowNewsDetail,
        },
        {
          path: "/show-message",
          name: "ShowMessage",
          component: ShowMessage,
          children: [
            {
              path: "show-bopin-news",
              name: "show-bopin-news",
              component: bopingRouter,
            },
          ],
        },
        {
          path: "/show-acrobatics",
          name: "showAcrobatics",
          component: showAcrobatics,
        },
        {
          path: "/show-story",
          name: "showStory",
          component: showStory,
        },
        {
          path: "/show-help",
          name: "ShowHelp",
          component: ShowHelp,
        },
        {
          path: "/show-privacy-policy",
          name: "ShowPrivacyPolicy",
          component: ShowPrivacyPolicy,
        },
        {
          path: "/company-grow",
          name: "CompanyGrow",
          component: CompanyGrow,
        },
        {
          path: "/recruitment-skills_to",
          name: "recruitment-skills_to",
          component: recruitmentSkillsTo,
        },
        {
          path: "/job-hunting-skills-to",
          name: "job-hunting-skills-to",
          component: jobHuntingSkillsTo,
        },

        {
          path: "/show-news-ling",
          name: "show-news-ling",
          component: showNewsLing,
        },
        {
          path: "/show-live",
          name: "showLive",
          component: showLive,
        },
        {
          path: "/observe-the",
          name: "observeThe",
          component: observeThe,
        },
        {
          path: "/company-honor",
          name: "CompanyHonor",
          component: CompanyHonor,
        },
        {
          path: "/privacy-rules",
          name: "PrivacyRules",
          component: PrivacyRules,
        },
        {
          path: "/recruitment-skills",
          name: "RecruitmentSkills",
          component: RecruitmentSkills,
        },
        {
          path: "/job-hunting-skills",
          name: "JobHuntingSkills",
          component: JobHuntingSkills,
        },
        {
          path: "/job-hunting-skills",
          name: "JobHuntingSkills",
          component: JobHuntingSkills,
        },
        {
          path: "/ds/download",
          name: "DSDownload",
          component: () => import("@/pages/ds/download"),
        },
        {
          path: "/pa/download",
          name: "PADownload",
          component: () => import("@/pages/pa/download"),
        },
        {
          path: "/job/job",
          name: "JobEmployment",
          component: () => import("@/pages/job/job"),
        },
      ],
    },
    // 接受面试
    {
      path: "/AcceptInterview",
      name: "AcceptInterview",
      component: AcceptInterview,
    },
    // 自投简历
    {
      path: "/EditResume",
      name: "EditResume",
      component: EditResume,
    },
    // APP下载
    {
      path: "/appDownload",
      name: "appDownload",
      component: DownloadApp,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js